module.exports = __webpack_public_path__ + "img/dotted-border.34ede172.png";